export default "__VITE_ASSET__5d3b2c2a__"